import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      width: "360px",
    },
    mfaOtpScreenContainer: {
      display: "flex",
      gap: "16px",
      width: "360px",
    },
    rightContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      textAlign: "left",
    },
    mfaTitle: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
      fontFamily: `"Red Hat Display", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
    mfaDescription: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      marginTop: 8,
      fontFamily: `"Red Hat Text", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
    mfaLabel: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
      marginTop: 16,
      fontFamily: `"Red Hat Display", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
    mfaOtpSection: {
      marginTop: 16,
    },
    passcodeError: {
      ...theme.fonts.h5,
      color: theme.colors.error,
      textAlign: "left",
      fontFamily: `"Red Hat Display", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
    exceededAttemptPasscodeError: {
      marginTop: 16,
      ...theme.fonts.h5,
      color: theme.colors.error,
      textAlign: "left",
      fontFamily: `"Red Hat Display", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
    passcodeTextfieldContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
    passcodeCharacterTextfield: {
      height: "45px !important",
      width: "45px",
      borderRadius: 0,
      "& input": {
        textAlign: "center",
      },
    },
    mfaButtonContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      marginTop: 16,
      gap: "16px",
      "& > *": {
        borderRadius: 0,
      },
    },
    activationButtonContainer: {
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      marginTop: 32,
      "& > *": {
        borderRadius: 0,
      },
    },
    mfaActionButtonsContainer: {
      display: "flex",
      gap: 8,
      justifyContent: "space-between",
      "& > *": {
        flex: 1,
        borderRadius: 0,
      },
    },
    activationActionButtonsContainer: {
      display: "flex",
      gap: 8,
      justifyContent: "space-between",
      "& > *": {
        borderRadius: 0,
      },
    },

    otpCodeDescription: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      marginTop: 8,
      fontFamily: `"Red Hat Text", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
    otpInformation: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      marginTop: 32,
      fontFamily: `"Red Hat Text", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important`,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
